"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = SignaturePad;
var _react = _interopRequireWildcard(require("react"));
var _signature_pad = _interopRequireDefault(require("signature_pad"));
var _styles = require("./styles");
var _lodash = require("lodash");
var _messages = _interopRequireDefault(require("./messages"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function SignaturePad(_ref) {
  var signature = _ref.signature,
    onSubmit = _ref.onSubmit,
    formatMessage = _ref.formatMessage;
  var signaturePad = (0, _react.useRef)(null);
  var previewButtonRef = (0, _react.useRef)(null);
  var _useState = (0, _react.useState)(),
    _useState2 = _slicedToArray(_useState, 2),
    previewButtonSize = _useState2[0],
    setPreviewButtonSize = _useState2[1];
  var _useState3 = (0, _react.useState)(_styles.COLORS.black),
    _useState4 = _slicedToArray(_useState3, 2),
    selectedColor = _useState4[0],
    setSelectedColor = _useState4[1];
  var _useState5 = (0, _react.useState)(false),
    _useState6 = _slicedToArray(_useState5, 2),
    dialogOpen = _useState6[0],
    setDialogOpen = _useState6[1];
  var canvasSize = (0, _react.useMemo)(function () {
    var width = (0, _lodash.clamp)(2 * window.innerWidth / 3, 360, 720);
    var height = width / 2;
    return {
      width: width,
      height: height
    };
  }, []);
  (0, _react.useEffect)(function () {
    setPreviewButtonSize(previewButtonRef.current.getBoundingClientRect());
  }, []);
  (0, _react.useEffect)(function () {
    if (!dialogOpen) return;
    var canvas = document.getElementById('signature-pad');
    signaturePad.current = new _signature_pad["default"](canvas, {
      throttle: 0
    });
    if (signature.points) {
      var tmpRatio = window.devicePixelRatio;
      window.devicePixelRatio = 1;
      signaturePad.current.fromData(signature.points);
      window.devicePixelRatio = tmpRatio;
    }
  }, [signature.data, dialogOpen]);
  var getSignature = function getSignature(e) {
    e.preventDefault();
    if (signaturePad.current.isEmpty()) {
      onSubmit(undefined);
    } else {
      var tmpRatio = window.devicePixelRatio;
      window.devicePixelRatio = 1;
      var data = signaturePad.current.toDataURL('image/svg+xml');
      var svg = signaturePad.current.toSVG({
        includeBackgroundColor: true
      });
      var points = signaturePad.current.toData();
      onSubmit({
        data: data,
        points: points,
        svg: svg
      });
      window.devicePixelRatio = tmpRatio;
    }
    closeModal(e);
  };
  var clearSignature = function clearSignature(e) {
    e.preventDefault();
    signaturePad.current.clear();
  };
  var closeModal = function closeModal(e) {
    e.preventDefault();
    setDialogOpen(false);
    window['signature-dialog'].close();
  };
  var onCancel = function onCancel(e) {
    e.preventDefault();
    closeModal(e);
  };
  var openModal = function openModal(e) {
    e.preventDefault();
    setDialogOpen(true);
    setSelectedColor(_styles.COLORS.black);
    window['signature-dialog'].showModal();
  };
  var setColor = function setColor(color) {
    setSelectedColor(color);
    signaturePad.current.penColor = color;
  };
  return /*#__PURE__*/_react["default"].createElement(_styles.SignaturePadWrapper, {
    style: {
      display: 'flex',
      flex: 1
    }
  }, /*#__PURE__*/_react["default"].createElement(_styles.PreviewButton, {
    ref: previewButtonRef,
    onClick: openModal,
    maxHeight: previewButtonSize === null || previewButtonSize === void 0 ? void 0 : previewButtonSize.height,
    maxWidth: previewButtonSize === null || previewButtonSize === void 0 ? void 0 : previewButtonSize.width
  }, signature.data ? /*#__PURE__*/_react["default"].createElement("img", {
    src: signature.data,
    width: previewButtonSize === null || previewButtonSize === void 0 ? void 0 : previewButtonSize.width,
    height: previewButtonSize === null || previewButtonSize === void 0 ? void 0 : previewButtonSize.height
  }) : /*#__PURE__*/_react["default"].createElement(_styles.Placeholder, null, formatMessage(_messages["default"].clickToSign))), /*#__PURE__*/_react["default"].createElement(_styles.Dialog, {
    id: "signature-dialog",
    onClick: closeModal
  }, /*#__PURE__*/_react["default"].createElement(_styles.DialogContent, {
    canvasSize: canvasSize,
    onClick: function onClick(e) {
      e.preventDefault();
      e.stopPropagation();
    }
  }, dialogOpen && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_styles.Header, null, /*#__PURE__*/_react["default"].createElement(_styles.Title, null, formatMessage(_messages["default"].signature)), /*#__PURE__*/_react["default"].createElement(_styles.CloseButton, {
    onClick: closeModal
  })), /*#__PURE__*/_react["default"].createElement(_styles.CanvasContainer, {
    width: canvasSize.width,
    height: canvasSize.height
  }, /*#__PURE__*/_react["default"].createElement(_styles.Pad, {
    id: "signature-pad",
    width: canvasSize.width,
    height: canvasSize.height
  }), /*#__PURE__*/_react["default"].createElement(_styles.ClearButton, {
    onClick: clearSignature
  }, formatMessage(_messages["default"].clear)), /*#__PURE__*/_react["default"].createElement(_styles.ColorsContainer, null, Object.values(_styles.COLORS).map(function (color) {
    return /*#__PURE__*/_react["default"].createElement(_styles.ColorButton, {
      key: color,
      color: color,
      onClick: function onClick() {
        return setColor(color);
      },
      selected: selectedColor === color
    });
  }))), /*#__PURE__*/_react["default"].createElement(_styles.ButtonContainer, null, /*#__PURE__*/_react["default"].createElement(_styles.Button, {
    onClick: onCancel,
    secondary: true
  }, formatMessage(_messages["default"].cancel)), /*#__PURE__*/_react["default"].createElement(_styles.Button, {
    onClick: getSignature
  }, formatMessage(_messages["default"].acceptAndSign)))))));
}
//# sourceMappingURL=index.js.map